import type { ReactNode } from 'react'

/**
 * The page body. It flows at its natural height and never scrolls on its own:
 * the unified shell's <main> is the one scroller, and on phones it carries
 * padding for the floating top row and search circle that is meant to scroll
 * past. A fixed-height scroller here (`h-full overflow-y-auto`, until
 * 2026-10-18) kept that padding on screen as white bars at the top and bottom
 * of every page, and made this div the thing that panned sideways.
 */
export function Page({ children }: { children?: ReactNode }) {
  return <div className="min-w-0 p-3 px-4">{children}</div>
}
